// The analytics leaf every call site imports, shaped like `simApi` in
// src/sim/api.ts: no-ops until the boot calls `setAnalytics`. It imports no
// runtime module, so a seam under src/atlas/ or src/sim/ reaches it without
// importing main.ts or atlas.ts.

import type { EventName, EventParams } from './events.ts';

export interface Analytics {
  /** Queue one event. Never calls a sink, so a call from frame code costs a push. */
  track<N extends EventName>(name: N, params: EventParams[N]): void;
  /** The menu pane on screen changed: one input to the page view. */
  menuTab(id: string): void;
  /** The Atlas's render scale moved: `perf_summary` reports the lowest one per view. */
  renderScale(scale: number): void;
}

const noop: Analytics = {
  track: () => {},
  menuTab: () => {},
  renderScale: () => {},
};

let current: Analytics = noop;

export const analytics: Analytics = { ...noop };

export function setAnalytics(impl: Analytics): void {
  current = impl;
  analytics.track = impl.track;
  analytics.menuTab = impl.menuTab;
  analytics.renderScale = impl.renderScale;
}

/** Put the no-ops back, if `impl` is still the one installed. */
export function clearAnalytics(impl: Analytics): void {
  if (current === impl) setAnalytics(noop);
}

export function track<N extends EventName>(name: N, params: EventParams[N]): void {
  analytics.track(name, params);
}
